export enum StatTypes {
  descriptor = 'descriptor',
  typeSkill = 'typeskill',
  role = 'role',
  hats = 'hats',
}
